// Centralized table and field name references for the project

export const TABLES = {
	ASSEMBLY: 'assembly',
	ASSEMBLY_CATEGORY: 'assembly_category',
	DISTRICT: 'district',
	DISTRICT_CATEGORY: 'district_category',
	INVITES: 'invites',
	ISSUES: 'issues',
	LOCAL_BODY: 'local_body',
	LOCAL_BODY_CATEGORY: 'local_body_category',
	LOCAL_BODY_TYPE: 'local_body_type',
	PROFILES: 'profiles',
	TOWN: 'town',
	WARD: 'ward',
	WARD_COLLECTION: 'ward_collection',
};

export const FIELDS = {
	ASSEMBLY: {
		ID: 'id',
		NAME_EN: 'name_en',
		NAME_ML: 'name_ml',
		DISTRICT_ID: 'district_id',
		IS_ACTIVE: 'is_active',
	},
	ASSEMBLY_CATEGORY: {
		ASSEMBLY_ID: 'assembly_id',
		CATEGORY: 'category',
	},
	DISTRICT: {
		ID: 'id',
		NAME_EN: 'name_en',
		NAME_ML: 'name_ml',
		IS_ACTIVE: 'is_active',
	},
	DISTRICT_CATEGORY: {
		DISTRICT_ID: 'district_id',
		CATEGORY: 'category',
	},
	INVITES: {
		ROLE: 'role',
		EMAIL: 'email',
		USED: 'used',
		CREATED_AT: 'created_at',
		ID: 'id',
		TOKEN: 'token',
		LOCAL_BODY_ID: 'local_body_id',
	},
	ISSUES: {
		LOCATION_URL: 'location_url',
		DESCRIPTION: 'description',
		TYPE: 'type',
		LOCAL_BODY_ID: 'local_body_id',
		CREATED_AT: 'created_at',
		RESOLVED: 'resolved',
		ID: 'id',
		TOWN_ID: 'town_id',
		IMAGE_URL: 'image_url',
	},
	LOCAL_BODY: {
		NAME_EN: 'name_en',
		ID: 'id',
		BLOCK_NAME_EN: 'block_name_en',
		DIST_PANCHAYAT_NAME_EN: 'district_panchayat_name_en',
		NAME_ML: 'name_ml',
		ASSEMBLY_ID: 'assembly_id',
		TYPE_ID: 'local_body_type_id',
		IS_ACTIVE: 'is_active',
	},
	LOCAL_BODY_CATEGORY: {
		LOCAL_BODY_ID: 'local_body_id',
		CATEGORY: 'category',
	},
	LOCAL_BODY_TYPE: {
		NAME_ML: 'name_ml',
		TYPE_ID: 'id',
		NAME_EN: 'name_en',
	},
	PROFILES: {
		CREATED_AT: 'created_at',
		ID: 'id',
		LOCAL_BODY_ID: 'local_body_id',
		ROLE: 'role',
	},
	TOWN: {
		NAME_ML: 'name_ml',
		NAME_EN: 'name_en',
		CREATED_AT: 'created_at',
		ID: 'id',
		LOCAL_BODY_ID: 'local_body_id',
		LAT: 'lat',
		LNG: 'lng',
	},
	TOWN_STATUS: {
		STATUS_ID: 'status_id',
		TOWN_ID: 'town_id',
		CREATED_AT: 'created_at',
		HAS_PROPER_BIN_USAGE: 'has_proper_bin_usage',
		MEETS_CLEANLINESS_STANDARDS: 'meets_cleanliness_standards',
		HAS_SUFFICIENT_BINS: 'has_sufficient_bins',
		IS_CURRENT: 'is_current',
	},	
	WARD: {
		NAME_ML: 'name_ml',
		NAME_EN: 'name_en',
		ELECTED_MEMBER_EN: 'elected_member_en',
		ROLE: 'role',
		PARTY: 'party',
		RESERVATION: 'reservation',
		LAST_PATH_SEGMENT: 'last_path_segment',
		ID: 'id',
		WARD_NO: 'ward_no',
		LOCAL_BODY_ID: 'local_body_id',
		ELECTED_MEMBER_ML: 'elected_member_ml',
	},
	WARD_COLLECTION: {
		WARD_ID: 'ward_id',
		YEAR_MONTH: 'year_month',
		RATE: 'rate',
		COLLECTION_ID: 'collection_id',
	},
};
